<template>
  <div
    class="main"
    data-app="true"
  >
    <!-- Might be possible to put this in the account home header instead -->
    <Gondola v-if="showGondola" />
    <router-view />
  </div>
</template>

<script>
import Gondola from '../Gondola.vue';

export default {
  name:  'DMOfferCodeApp',
  metaInfo: {
    title: 'Redeem Your Offer',
    titleTemplate: '%s | NetCredit',
  },
  components: {
    Gondola,
  },
  data() {
    return {
      showGondola: window.__showGondola__,
    }
  }

};
</script>
